import type {
  DropdownOptionsPathParams,
  DropdownOptionsSourceConfig,
  FetchDropdownOptionsArgs
} from './types';

const PATH_PARAM_PATTERN = /:([A-Za-z0-9_]+)/g;

export const resolveDropdownOptionsPath = (
  pathTemplate: string,
  pathParams: DropdownOptionsPathParams = {}
): string => {
  return pathTemplate.replace(PATH_PARAM_PATTERN, (_, key: string) => {
    const value = pathParams[key];

    if (value == null || value === '') {
      throw new Error(`Missing path param "${key}" for "${pathTemplate}"`);
    }

    return encodeURIComponent(value.toString());
  });
};

export const serializeDropdownPathParams = (pathParams: DropdownOptionsPathParams = {}): string => {
  return Object.entries(pathParams)
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
};

export const buildDropdownOptionsCacheKey = ({
  source,
  pathParams,
  search
}: FetchDropdownOptionsArgs): string => {
  const resolvedPath = resolveDropdownOptionsPath(source.pathTemplate, pathParams);
  const normalizedSearch = (search || '').trim().toLowerCase();

  return [source.key, resolvedPath, normalizedSearch].join('|');
};

export const buildDropdownOptionsRequestMeta = ({
  source,
  pathParams,
  search
}: FetchDropdownOptionsArgs): {
  source: DropdownOptionsSourceConfig;
  resolvedPath: string;
  search: string;
  cacheKey: string;
} => {
  const resolvedPath = resolveDropdownOptionsPath(source.pathTemplate, pathParams);
  const normalizedSearch = (search || '').trim();

  return {
    source,
    resolvedPath,
    search: normalizedSearch,
    cacheKey: buildDropdownOptionsCacheKey({ source, pathParams, search: normalizedSearch })
  };
};
